/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVlastnostHodnota extends GContentBase<SeznamAdmVlastnostHodnotaObj> {
        private seznamObj: SeznamAdmVlastnostHodnotaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVlastnostHodnotaObj());
            var columnOrder = "{0}hovla,hovla_txt,dat_zmena,zmenu_prov_txt";
            var ixsVlaTxt = "";
            if (this.seznamObj.tabOpen == undefined || this.seznamObj.tabOpen == null)
                ixsVlaTxt = "ixs_vla_txt,";
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVlastnostHodnotaNew",
                contentCaption: "jres:33000457", //RC 33000457 : Hodnoty vlastnost�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_vla_txt} - {hovla}"
                },
                gridSettings: {
                    columnOrder: columnOrder.format(ixsVlaTxt)
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVlastnostHodnotaObj extends GAdmSeznamBase {
        private ixs_vla: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmVlastnostHodnota", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVlastnostHodnota",
                newRecord: isNew,
                ixs_vla: isNew == true ? (this.ixs_vla ? this.ixs_vla : null) : data.ixs_vla,
                hovla: isNew == true ? null : data.hovla
            }, {
                height: 800,
                width: 800
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29932128").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                dropdown: true,
                model: "model.ixs_vla=value.ixs_vla",
                name: "ixs_vla",
                disabled: (this.ixs_vla) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_vla)
                hardFilter["ixs_vla"] = this.ixs_vla;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_vla)
                data["ixs_vla"] = this.ixs_vla;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVlastnostHodnota.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.ixs_vla, data.hovla),
                nazev: "{0} - {1}".format(data["ixs_vla_txt"], data["hovla"])
            }
        }
    }
}